// Environment-based API configuration
const getServerApi = () => {
  // Check for environment variable first (for production builds)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Fallback to default production URL
  return 'https://api.inventring.com';
  // return 'http://localhost:3000';
};

export const baseUrl = getServerApi();

